import React from 'react';
import CarReservContainer from '../../containers/carmng/CarReservContainer';

const CarReservPage = () => {
  return (
    <>
      <CarReservContainer />
    </>
  );
};

export default CarReservPage;